'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "onClose"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFieldset from 'UIComponents/form/UIFieldset';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { KeyTypes } from '../../constants/popover';
import CalloutTypeList from './CalloutTypeList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.callout.edit.${suffix}`;
const propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
function CalloutPopoverBodyEdit(props) {
  const {
      onChange,
      onClose
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleCloseOnEscape = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      onClose();
    }
  };
  return /*#__PURE__*/_jsxs(UIFieldset, {
    className: "small-popover-body p-all-5",
    tabIndex: "-1",
    onKeyDown: handleCloseOnEscape,
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx("h4", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('title')
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        color: EERIE,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text(i18nKey('subTitle')),
      children: /*#__PURE__*/_jsx(CalloutTypeList, Object.assign({}, rest, {
        buttonClassName: "p-x-3 p-y-2",
        onClick: onChange
      }))
    })]
  });
}
CalloutPopoverBodyEdit.propTypes = propTypes;
CalloutPopoverBodyEdit.displayName = 'CalloutPopoverBodyEdit';
export default CalloutPopoverBodyEdit;